import { ArrowDown, ArrowUp } from 'lucide-react';
import StyledButton from './StyledButton';
import { Column } from '@tanstack/react-table';

interface StyledTableHeaderProps<ColumnType> {
  column: Column<ColumnType>;
  title: string;
}

const StyledTableHeader = <ColumnType,>({
  column,
  title,
}: StyledTableHeaderProps<ColumnType>) => (
  <StyledButton
    variant="link"
    className="p-0 text-gray-500"
    title={title}
    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
    icon={
      column.getIsSorted() === 'asc' ? (
        <ArrowUp className="w-5 h-5" />
      ) : (
        <ArrowDown className="w-5 h-5" />
      )
    }
    iconPosition="right"
  />
);

export default StyledTableHeader;
